import { ChangeEvent } from './ChangeEvent';

export function ChangeLogRail({ changes = [] }: { changes?: Array<Parameters<typeof ChangeEvent>[0]['change']> }) {
  return <aside className="rounded-[10px] border border-border bg-card p-4" aria-labelledby="change-log-heading"><h2 id="change-log-heading" className="font-semibold">Change log</h2>{changes.length === 0 ? <p className="mt-2 text-sm text-muted-foreground">No changes recorded yet.</p> : changes.map((change, index) => <ChangeEvent key={`${change.at ?? 'change'}-${index}`} change={change} />)}</aside>;
}

export default ChangeLogRail;
